<ng-container *ngIf="words.length > 0">
  <div class="word-group" *ngFor="let word of words">
    <div class="group {{ ch.textCss }}" *ngFor="let ch of word">
      <div class="row seungjo {{ ch.seungjoCss }}"></div>
      <div class="row txt">
        <div class="con {{ ch.textCss }} {{ ch.highlightCss }}">{{ ch.text }}</div>
      </div>
    </div>
  </div>
</ng-container>
